import MapCharacterDefinition from "../model/MapCharacterDefinition";

export default class MapCharacterInteractionEvent {
    /**
     * @constructor
     * @param {string} type 
     * @param {MapCharacterDefinition} character 
     */
    constructor(type, character) {
        this.type = type;
        this.character = character;
    }
}

MapCharacterInteractionEvent.CLICK = "MapCharacterInteractionEvent.CLICK";
MapCharacterInteractionEvent.ENTER = "MapCharacterInteractionEvent.ENTER";